
















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Carousel, Slide } from 'vue-carousel';

@Component({
  components: {
    Carousel,
    Slide
  },
  data: () => ({
    touch: 0
  })
})
export default class Slider extends Vue {
  @Prop({
    type: Array,
    required: true
  })
  private images!: string[];
  private touch!: number;

  private touchStart(ev: TouchEvent) {
    this.touch = ev.changedTouches[0].screenX;
  }

  private touchEnd(ev: TouchEvent) {
    const start = this.touch;
    const end = ev.changedTouches[0].screenX;
    if (end < start) {
      $('#slider').carousel('next');
    } else if (end > start) {
      $('#slider').carousel('prev');
    }
  }

  private active(index: number) {
    return {
      active: index === 0
    };
  }
}
